<div class="home">
	<section class="cover">
		<div class="container">
			<div class="text-container">
				<h1>{{'Home.Section1.Title' | translate }}</h1>
				<p>{{'Home.Section1.Text' | translate }}</p>
				<a [routerLink]="'/furniture' | getRoute" class="btn-black">
					{{'Button.ViewAll' | translate}}
				</a>
			</div>

			<div class="image-container">
				<img src="/assets/images/home/drinjaca-production-site.jpeg" alt="drinjaca">
			</div>
		</div>
	</section>

	<section class="drina">
		<div class="container">
			<div class="logo-container">
				<img src="../../assets/images/home/drina-logo.png" alt="drina logo">
			</div>
			<div class="text-container">
				<p>{{ 'Home.Drina.Text' | translate }}</p>
				<a class="btn-black" href="assets/pdf/Drina-2024.pdf" target="_blank">{{'Button.LearnMore' | translate }}</a>
			</div>
		</div>
	</section>

	<section class="production-program">
		<div class="container">
			<div class="title-section">
				<span class="black-line"></span>
				<div class="text-wrapper">
					<h2>{{'Home.Section2.Title' | translate }}</h2>
					<span class="bottom-line"></span>
					<p>
						{{'Home.Section2.Text' | translate }}
					</p>
				</div>
			</div>

			<div class="products">
				<div class="categories">

					<div class="cat-wrap">
						<div class="image-container">
							<img src="../../assets/images/home/namjestaj.jpg" alt="namestaj">
						</div>
						<div class="text">
							<div class="inner">
								<div class="wrap">
									<h3>
										{{'Home.Section3.Title' | translate }}
									</h3>
									<p class="paragraph">
										{{'Home.Section3.Text' | translate }}
									</p>
								</div>
								<a [routerLink]="'/furniture' | getRoute" class="btn-black">
									{{'Button.LearnMore' | translate}}
								</a>
							</div>
						</div>
					</div>

					<div class="cat-wrap">
						<div class="image-container">
							<img src="../../assets/images/home/lamelirane-ploce.jpg" alt="lamelirane ploce">
						</div>
						<div class="text">
							<div class="inner">
								<h3>
									{{'Home.Section4.Title' | translate }}
								</h3>
								<p class="paragraph">
									{{'Home.Section4.Text' | translate }}
								</p>
								<a [routerLink]="'/boards' | getRoute" class="btn-black">
									{{'Button.LearnMore' | translate}}
								</a>
							</div>
						</div>

					</div>

					<div class="cat-wrap">
						<div class="image-container">
							<img src="../../assets/images/home/briketi.jpg" alt="briketi">
						</div>
						<div class="text">
							<div class="inner">
								<h3>
									{{'Home.Section5.Title' | translate }}
								</h3>
								<p class="paragraph">
									{{'Home.Section5.Text' | translate }}
								</p>
								<a [routerLink]="'/briquettes' | getRoute" class="btn-black">
									{{'Button.LearnMore' | translate}}
								</a>
							</div>
						</div>

					</div>

					<div class="cat-wrap">
						<div class="image-container">
							<img src="../../assets/images/home/rezana-gradja.jpg" alt="rezana gradja">
						</div>
						<div class="text">
							<div class="inner">
								<h3>
									{{'Home.Section6.Title' | translate }}
								</h3>
								<p class="paragraph">
									{{'Home.Section6.Text' | translate }}
								</p>
								<a [routerLink]="'/sawn-timber' | getRoute" class="btn-black">
									{{'Button.LearnMore' | translate}}
								</a>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</section>
	<app-banner [isTitlePresent]="true" [iconColor]="'black'" [color]="'var(--blackColor)'"
		[backgroundColor]="'var(--whiteColor)'">
	</app-banner>

	<section class="gray-section">
		<div class="container">
			<div class="black-section">
				<div class="inner">
					<h2>{{'Home.Section8.Title' | translate }}</h2>
					<p>{{'Home.Section8.Text' | translate }}</p>
					<a class="btn-white" [routerLink]="'/furniture' | getRoute">{{'Button.LearnMore' | translate }}</a>
				</div>
			</div>

			<div class="slider">
				<img src="assets/images/home/1.png" alt="Slider image 1" />
				<!-- <owl-carousel-o class="owl-carousel" [options]="customOptions">
							<ng-container>

								<ng-template carouselSlide>
									<div class="item">
										<img src="assets/images/home/1.png" alt="Slider image 1" />
									</div>
								</ng-template>

								<ng-template carouselSlide>
									<div class="item w-100 h-100">
										<img src="assets/images/home/1.png" alt="Slider image 1" />
									</div>
								</ng-template>

							</ng-container>
						</owl-carousel-o> -->

			</div>
		</div>
	</section>
	<div class="contact-form-section">
		<app-common-contact-form></app-common-contact-form>
	</div>


</div>
